export abstract class AuthenticationError extends Error {
  public readonly messageId: string

  constructor(message: string, messageId: string) {
    super(message)
    this.name = 'AuthenticationError'
    this.messageId = messageId
    Object.setPrototypeOf(this, AuthenticationError.prototype)
  }
}

export class InvalidCredentialsError extends AuthenticationError {
  constructor() {
    super('Incorrect username or password', 'notification.loginError')
    this.name = 'InvalidCredentialsError'
  }
}

export class UserNotActiveError extends AuthenticationError {
  constructor() {
    super('User is not active', 'notification.userNotActive')
    this.name = 'UserNotActiveError'
  }
}
